import { TextInput } from '../index';
import React, { useEffect, useState } from 'react';
import { Flex } from '@chakra-ui/react';
import ActionButton from '../ActionButton';
import { Check, Edit, Trash } from 'react-feather';

const ElementControlled = ({
	i,
	first,
	second,
	values,
	changeValues,
	handleDelete
}) => {
	const [edit, setEdit] = useState(false);
	const [state, setState] = useState(
		values ? values[i] : { [first.name]: '', [second.name]: '' }
	);

	const handleEdit = (e) => {
		changeValues(i, state);
		setEdit(false);
	};

	const handleChange = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	useEffect(() => {
		if (i === values.length - 1) {
			setEdit(true);
		}
	}, []);

	return (
		<Flex alignItems={'flex-end'} justifyContent={'start'} gap={10}>
			<TextInput
				caption={first.caption}
				id={`${first.name}-${i}`}
				name={first.name}
				value={state[first.name]}
				type="text"
				onChange={handleChange}
				style={{ width: '40%' }}
				inputProps={{ readOnly: !edit }}
				autoFocus={i === values.length - 1}
				isRequired
			/>
			<TextInput
				caption={second.caption}
				name={second.name}
				type="text"
				value={state[second.name]}
				id={`${second.name}-${i}`}
				onChange={handleChange}
				style={{ width: '40%' }}
				inputProps={{ readOnly: !edit }}
				isRequired
			/>
			<Flex style={{ marginBottom: '1.2rem' }}>
				{edit ? (
					<ActionButton
						size={'25px'}
						id={`deleteElementAction-${i}`}
						hoverColor={'red'}
						icon={<Check size={20} />}
						onClick={handleEdit}
					/>
				) : (
					<ActionButton
						size={'25px'}
						id={`deleteElementAction-${i}`}
						hoverColor={'red'}
						icon={<Edit size={20} />}
						onClick={() => setEdit(true)}
					/>
				)}
				<ActionButton
					size={'25px'}
					id={`deleteElementAction-${i}`}
					hoverColor={'red'}
					icon={<Trash size={20} />}
					onClick={(e) => {
						handleDelete(i, e);
					}}
				/>
			</Flex>
		</Flex>
	);
};

export default ElementControlled;
